import {
  invalidateAttendances,
  invalidateAttributes,
  invalidateBreaks,
  invalidateConfigs,
  invalidateContactTemplates,
  invalidateDepartments,
  invalidateHiringData,
  invalidateHolidays,
  invalidatePermissions,
  invalidatePositions,
  invalidateProjects,
  invalidatePunchRules,
  invalidateRequestFields,
  invalidateScheduleTemplates,
  invalidateScheduleTypes,
  invalidateTags,
  invalidateTeams,
  invalidateUserFilters,
  invalidateUserProcedures,
  invalidateUsers,
  invalidateUserSorts,
  invalidateUserTemplates,
  invalidateWagePremiums
} from 'Api'

const queryInvalidationMap = {
  attendances: invalidateAttendances,
  attributes: invalidateAttributes,
  breaks: invalidateBreaks,
  configs: invalidateConfigs,
  contactTemplates: invalidateContactTemplates,
  departments: invalidateDepartments,
  hiringData: invalidateHiringData,
  holidays: invalidateHolidays,
  permissions: invalidatePermissions,
  positions: invalidatePositions,
  projects: invalidateProjects,
  punchRules: invalidatePunchRules,
  requestFields: invalidateRequestFields,
  scheduleTemplates: invalidateScheduleTemplates,
  scheduleTypes: invalidateScheduleTypes,
  tags: invalidateTags,
  teams: invalidateTeams,
  userFilters: invalidateUserFilters,
  userProcedures: invalidateUserProcedures,
  users: invalidateUsers,
  userSorts: invalidateUserSorts,
  userTemplates: invalidateUserTemplates,
  wagePremiums: invalidateWagePremiums
} as const

type Queries = keyof typeof queryInvalidationMap

const invalidateQueries = (queries: Queries[]) => {
  queries.forEach(query => {
    const invalidateQuery = queryInvalidationMap[query]

    if (!invalidateQuery) return

    invalidateQuery()
  })
}
export { invalidateQueries }
